import React, { useState } from 'react'

import { CTA } from 'goustouicomponents'
import { useDispatch } from 'react-redux'

import { trackUTMAndPromoCode } from 'actions/tracking'
import { boxPricesClickRecipeNumber } from 'actions/trackingKeys'
import { boxTypes, cta } from 'routes/BoxPrices/boxPricesConfig'
import { Benefits } from 'routes/Home/Benefits'

import { boxPricesBoxSizeSelected } from '../boxPricesActions'
import { BoxPriceSuitableForSection } from './BoxPriceSuitableForSection'
import { BoxPriceBlockProps } from './boxPriceBlockModels'

import css from './BoxPriceBlock.css'

const BoxPriceBlock = ({ boxInfo, numPersons, selectedBox }: BoxPriceBlockProps) => {
  const recipesLeftTrackingIndex = boxInfo.length - 1
  const [selectedIndex, setSelectedIndex] = useState(recipesLeftTrackingIndex)
  const { title, boxSizeTrackingValue } = boxTypes[numPersons]

  const dispatch = useDispatch()

  const dispatchBoxProcesBoxSelected = () => dispatch(boxPricesBoxSizeSelected(numPersons))

  const dispatchTrackUTMAndPromoCode = (numRecipes: number) =>
    dispatch(
      trackUTMAndPromoCode(boxPricesClickRecipeNumber, {
        box_size: boxSizeTrackingValue,
        number_of_recipes: numRecipes,
      }),
    )

  return (
    <div className={numPersons === selectedBox ? css.containerActive : css.container}>
      <div className={css.carouselItem}>
        <h2 className={css.itemHeading}>{title}</h2>
        <BoxPriceSuitableForSection numPersons={numPersons} />
        <p className={css.subhead}>Select number of recipes</p>
        <div className={css.buttonGroup}>
          {boxInfo.map((item, index) => {
            const numRecipes = item.num_portions

            return (
              <button
                key={numRecipes}
                type="button"
                onClick={() => {
                  dispatchTrackUTMAndPromoCode(numRecipes)
                  setSelectedIndex(index)
                }}
                className={selectedIndex === index ? css.boxSizeButtonActive : css.boxSizeButton}
              >
                {numRecipes}
              </button>
            )
          })}
        </div>
        {recipesLeftTrackingIndex - selectedIndex > 0 ? (
          <div className={css.selectDescription}>
            {`Select ${recipesLeftTrackingIndex - selectedIndex} more recipe${
              selectedIndex === recipesLeftTrackingIndex - 1 ? '' : 's'
            } for the best price`}
          </div>
        ) : (
          <div className={css.selectDescriptionSuccess}>You’ve got the best price per portion!</div>
        )}
        <div className={css.select}>
          <div className={css.selectItem}>
            <span className={css.amount}>£{boxInfo[selectedIndex].total}</span>
            <br />
            per box
          </div>
          <div className={css.selectItem}>
            <span className={css.amount}>£{boxInfo[selectedIndex].price_per_portion}</span>
            <br />
            per portion
          </div>
        </div>
        <div className={css.benefitContainer}>
          <Benefits byId="paidDelivery" isCentered fontStyleS isReverted />
        </div>
        <div className={css.ctaContainer}>
          <CTA isFullWidth onClick={dispatchBoxProcesBoxSelected}>
            {cta}
          </CTA>
        </div>
        <div className={css.benefitContainer}>
          <Benefits byId="noLockIn" isCentered fontStyleS />
        </div>
      </div>
    </div>
  )
}

export { BoxPriceBlock }
